import NavigateBackToolbar from './NavigateBackToolbar';
import './NavigateBackToolbar.scss';

export default NavigateBackToolbar;
